import difficulty from '../../data/difficulty';

export default {
  numberOfPlayers: 1,
  difficulty: difficulty.easy,
  initialRuleCount: 3,
  phaseRuleCount: 1,
  showIncludedSkills: false,
  showActiveSkills: true,
  showPassiveSkills: true,
  showPhaseModal: false,
  showRuleRollModal: false,
  showSessionToken: false,
  showSessionMenu: false,
};
